import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref } from "vue";
import { SelectOption } from "@/types";
import { settingsTabOptions } from "@/util";
import { permissionStore } from "@/hooks";
import { TabList, SidebarGrid } from "@/components/common";
import {
  UploadNewVersion,
  ProjectButtons,
  ProjectDisplay,
  ProjectOverviewDisplay,
} from "@/components/project";
import { ProjectInstallationsTable } from "@/components/integrations";
import { AttributeSettings } from "@/components/attributes";
import { ProjectMemberTable } from "@/components/members";
import { JobsTable } from "@/components/jobs";


/**
 * Tabs for changing project settings.
 */
const __default__ = {
  name: "SettingsTabs",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const tabs = computed(() => {
  const options = settingsTabOptions();
  const visibleOptions: SelectOption[] = [options[0], options[1]];

  if (permissionStore.isAllowed("project.edit_versions")) {
    visibleOptions.push(options[2], options[3]);
  }
  if (permissionStore.isAllowed("project.edit_integrations")) {
    visibleOptions.push(options[4]);
  }
  if (permissionStore.isAllowed("project.edit")) {
    visibleOptions.push(options[5]);
  }

  return visibleOptions;
});
const tab = ref(tabs.value[0].id);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(SidebarGrid), null, {
    sidebar: _withCtx(() => [
      _createVNode(_unref(ProjectButtons)),
      _createVNode(_unref(ProjectDisplay))
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(TabList), {
        modelValue: tab.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
        tabs: tabs.value
      }, {
        overview: _withCtx(() => [
          _createVNode(_unref(ProjectOverviewDisplay), { "hide-title": "" })
        ]),
        members: _withCtx(() => [
          _createVNode(_unref(ProjectMemberTable))
        ]),
        jobs: _withCtx(() => [
          _createVNode(_unref(JobsTable), { "display-project-jobs": true })
        ]),
        upload: _withCtx(() => [
          _createVNode(_unref(UploadNewVersion), {
            open: tab.value === 'upload'
          }, null, 8, ["open"])
        ]),
        integrations: _withCtx(() => [
          _createVNode(_unref(ProjectInstallationsTable))
        ]),
        attributes: _withCtx(() => [
          _createVNode(_unref(AttributeSettings))
        ]),
        _: 1
      }, 8, ["modelValue", "tabs"])
    ]),
    _: 1
  }))
}
}

})